export const TRAVEL_REASONS = {
    1: {
        id: 1,
        name: `Client visit`,
        isDeleted: false,
    },
    2: {
        id: 2,
        name: `Ice Cream`,
        isDeleted: false,
    },
    3: {
        id: 3,
        name: `Lunch`,
        isDeleted: false,
    },
    4: {
        id: 4,
        name: `Old Job AA12993`,
        isDeleted: true,
    },
};



// WEBPACK FOOTER //
// ./scripts/constants/fakeData/travelReasons.js